module.exports = __webpack_public_path__ + "media/control_acceso/corredizo-48018fa8.png";